import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { Checkbox, getTestId, isLastItem, isValidObject, Radio, StateConfigContext, Typography } from '@airtel/air-design-system';
import { NUMBER_ZERO } from '../../TableWidgetConstants';
import { TableCell } from './components/table-cell';
import { TableHeader } from './components/table-header';
import { getTableStyles } from './TableStyles';
export var Table = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var tableStyles = getTableStyles(props, theme);
  var _props$header = props.header,
    header = _props$header === void 0 ? [] : _props$header,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list,
    _props$totalData = props.totalData,
    totalData = _props$totalData === void 0 ? [] : _props$totalData,
    setFinalTableDataList = props.setFinalTableDataList,
    setSelectedPageIndex = props.setSelectedPageIndex,
    _onHeaderIconPress = props.onHeaderIconPress,
    _onHeadingPress = props.onHeadingPress,
    _onSubHeadingPress = props.onSubHeadingPress,
    _onActionIconPress = props.onActionIconPress,
    _onDropdownItemPress = props.onDropdownItemPress,
    onSelectAllPress = props.onSelectAllPress,
    onSingleRowCheckboxPress = props.onSingleRowCheckboxPress,
    onRadioPress = props.onRadioPress,
    _onCtaPress = props.onCtaPress,
    _props$noDataText = props.noDataText,
    noDataText = _props$noDataText === void 0 ? 'No data available!' : _props$noDataText,
    _props$isRowPressable = props.isRowPressable,
    isRowPressable = _props$isRowPressable === void 0 ? false : _props$isRowPressable,
    columnsWidth = props.columnsWidth,
    _props$showCheckbox = props.showCheckbox,
    showCheckbox = _props$showCheckbox === void 0 ? false : _props$showCheckbox,
    _props$showRadio = props.showRadio,
    showRadio = _props$showRadio === void 0 ? false : _props$showRadio,
    style = props.style,
    onQuickFilterChange = props.onQuickFilterChange,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'Table' : _props$testID,
    onUserAction = props.onUserAction,
    tableData = props.tableData,
    maxWidthToBreakAll = props.maxWidthToBreakAll;
  var _useState = useState(list),
    listData = _useState[0],
    setListData = _useState[1];
  var _useState2 = useState(null),
    quickFilterList = _useState2[0],
    setQuickFilterList = _useState2[1];
  var _useState3 = useState(false),
    headerChecked = _useState3[0],
    setHeaderChecked = _useState3[1];
  var _useState4 = useState({}),
    checkBoxesState = _useState4[0],
    setCheckBoxesState = _useState4[1];
  var _useState5 = useState(-1),
    radioClickedIndex = _useState5[0],
    setRadioClickedIndex = _useState5[1];
  useEffect(() => {
    if (isValidObject(checkBoxesState)) {
      setHeaderChecked(true);
    } else setHeaderChecked(false);
  }, [checkBoxesState]);
  var onCheckboxPressHandler = (index, data) => {
    setCheckBoxesState(prev => {
      var checked = !(prev === null || prev === void 0 ? void 0 : prev[index]);
      var obj = Object.assign(Object.assign({}, prev), {
        [index]: checked
      });
      if (checked == false) {
        delete obj[index];
      }
      onSingleRowCheckboxPress === null || onSingleRowCheckboxPress === void 0 ? void 0 : onSingleRowCheckboxPress({
        data,
        checked
      });
      return obj;
    });
  };
  var onRadioButtonPressHandler = (index, data) => {
    setRadioClickedIndex(index);
    onRadioPress === null || onRadioPress === void 0 ? void 0 : onRadioPress(index, data);
  };
  var isIndeterminate = Object.keys(checkBoxesState).length === listData.length;
  var onSelectAllHandler = () => {
    setHeaderChecked(prev => {
      var checked = !prev;
      if (checked) {
        var data = {};
        for (var i = 0; i < listData.length; i++) {
          data[i] = true;
        }
        setCheckBoxesState(data);
        onSelectAllPress === null || onSelectAllPress === void 0 ? void 0 : onSelectAllPress({
          listData,
          checked
        });
      } else {
        setCheckBoxesState({});
        onSelectAllPress === null || onSelectAllPress === void 0 ? void 0 : onSelectAllPress({
          listData: [],
          checked
        });
      }
      return checked;
    });
  };
  var Wrapper = _ref => {
    var children = _ref.children,
      index = _ref.index;
    if (isRowPressable) {
      return _jsx(Pressable, Object.assign({
        style: state => {
          return [tableStyles.tableCellContainer, getPressableStyles(state), !isLastItem(listData, index) && tableStyles.bottomBorder, {
            zIndex: -1 - index
          }];
        }
      }, {
        children: children
      }));
    } else return _jsx(View, Object.assign({
      style: [tableStyles.tableCellContainer, !isLastItem(listData, index) && tableStyles.bottomBorder, {
        zIndex: -1 - index
      }]
    }, {
      children: children
    }));
  };
  useEffect(() => {
    setListData(list);
    createQuickFilterData();
  }, [JSON.stringify(list)]);
  var createQuickFilterData = () => {
    var quickFilterListWithIndex = {};
    header.map((item, i) => {
      var showQuickFilter = item.showQuickFilter,
        _item$quickFilterKey = item.quickFilterKey,
        quickFilterKey = _item$quickFilterKey === void 0 ? 'heading' : _item$quickFilterKey;
      if (showQuickFilter) {
        var logMapping = {};
        var headingList = totalData === null || totalData === void 0 ? void 0 : totalData.map((data, j) => {
          if (logMapping[data[i][quickFilterKey]] == undefined) {
            logMapping[data[i][quickFilterKey]] = [j];
          } else {
            logMapping[data[i][quickFilterKey]] = [...logMapping[data[i][quickFilterKey]], j];
          }
          return {
            checked: true,
            label: data[i][quickFilterKey],
            rowIndex: logMapping[data[i][quickFilterKey]]
          };
        });
        var _quickFilterList = [...new Map(headingList.map(item => [item.label, item])).values()];
        quickFilterListWithIndex[i] = _quickFilterList;
      }
    });
    setQuickFilterList(quickFilterListWithIndex);
  };
  var getPressableStyles = useCallback(event => {
    return event.hovered && tableStyles.hoverState;
  }, []);
  var onQuickFilterChangeHandler = data => {
    var filterList = data.filterList;
    var newFilterList = [];
    filterList.map(singleFilter => {
      if (singleFilter.checked) {
        singleFilter.rowIndex.map(singleRowIndex => {
          newFilterList.push(totalData && totalData[singleRowIndex]);
        });
      }
    });
    setFinalTableDataList(newFilterList);
    setSelectedPageIndex(NUMBER_ZERO);
    onQuickFilterChange === null || onQuickFilterChange === void 0 ? void 0 : onQuickFilterChange(newFilterList);
  };
  var formColumnWidth = (cellStyle, headerMinWidth) => {
    if (cellStyle !== null && cellStyle !== undefined) {
      return Object.assign(Object.assign({}, cellStyle), {
        minWidth: headerMinWidth,
        width: headerMinWidth
      });
    } else {
      return {
        minWidth: headerMinWidth,
        width: headerMinWidth
      };
    }
  };
  var getColumnWidth = index => {
    if (Array.isArray(columnsWidth) && columnsWidth[index]) return {
      flexGrow: columnsWidth[index] / 100
    };
  };
  var mergedStyleObj = (rightBorder, columnWidth, minWidth) => {
    return Object.assign(Object.assign(Object.assign({}, rightBorder), columnWidth), minWidth);
  };
  return _jsxs(View, Object.assign({
    style: [tableStyles.container, style]
  }, getTestId(testID), {
    children: [header.length > 0 && _jsxs(View, Object.assign({
      style: [tableStyles.tableHeaderContainer, tableStyles.bottomBorder]
    }, getTestId(testID, 'tableHeader'), {
      children: [showCheckbox && _jsx(View, Object.assign({
        style: tableStyles.checkboxContainer
      }, {
        children: _jsx(Checkbox, {
          onPress: onSelectAllHandler,
          checked: headerChecked,
          indeterminate: !isIndeterminate
        })
      })), showRadio && _jsx(View, Object.assign({
        style: tableStyles.radioContainer
      }, {
        children: _jsx(TableHeader, {})
      })), header.map((headerItem, i) => {
        return _createElement(TableHeader, Object.assign({}, headerItem, {
          index: i,
          key: "table_header_" + i,
          onHeaderIconPress: () => _onHeaderIconPress(headerItem),
          quickFilterList: quickFilterList === null || quickFilterList === void 0 ? void 0 : quickFilterList[i],
          onQuickFilterChange: onQuickFilterChangeHandler,
          style: [!isLastItem(header, i) && tableStyles.rightBorder, getColumnWidth(i), headerItem.style, {
            minWidth: headerItem === null || headerItem === void 0 ? void 0 : headerItem.minWidth,
            width: headerItem === null || headerItem === void 0 ? void 0 : headerItem.minWidth
          }]
        }, getTestId(testID, "tableHeader_" + i), {
          onUserAction: onUserAction,
          tableData: tableData,
          setSelectedPageIndex: setSelectedPageIndex
        }));
      })]
    })), (listData === null || listData === void 0 ? void 0 : listData.length) > 0 ? _jsx(View, Object.assign({
      style: tableStyles.tableScrollContainer
    }, getTestId(testID, 'tableCell'), {
      children: listData.map((item, i) => {
        return _jsx(Fragment, {
          children: (item === null || item === void 0 ? void 0 : item.length) > 0 && _jsxs(Wrapper, Object.assign({
            index: i
          }, getTestId(testID, "table_cell_" + i), {
            children: [showCheckbox && _jsx(View, Object.assign({
              style: [tableStyles.cellCheckbox, tableStyles.rightBorder]
            }, {
              children: _jsx(Checkbox, {
                checked: checkBoxesState[i],
                onPress: () => onCheckboxPressHandler(i, item)
              })
            })), showRadio && _jsx(View, Object.assign({
              style: [tableStyles.cellRadio, tableStyles.rightBorder]
            }, {
              children: _jsx(Radio, {
                checked: radioClickedIndex === i,
                onPress: () => onRadioButtonPressHandler(i, item)
              })
            })), item.map((cell, j) => {
              var _a;
              var selectedCellData = {
                rowIndex: i,
                colIndex: j,
                rowData: item,
                cellData: item[j]
              };
              return _createElement(TableCell, Object.assign({}, cell, {
                key: "table_cell_" + i + "_" + j,
                onHeadingPress: () => _onHeadingPress(selectedCellData),
                onSubHeadingPress: () => _onSubHeadingPress(selectedCellData),
                onCtaPress: () => _onCtaPress(selectedCellData),
                onActionIconPress: _ref2 => {
                  var onPress = _ref2.onPress,
                    selectedItem = _ref2.selectedItem;
                  if (typeof onPress === 'function') {
                    onPress(Object.assign({
                      selectedItem
                    }, selectedCellData));
                  } else {
                    _onActionIconPress(Object.assign({
                      onPress,
                      selectedItem
                    }, selectedCellData));
                  }
                },
                onDropdownItemPress: _ref3 => {
                  var selectedItem = _ref3.selectedItem;
                  _onDropdownItemPress(Object.assign({
                    selectedItem
                  }, selectedCellData));
                },
                maxWidthToBreakAll: maxWidthToBreakAll,
                style: mergedStyleObj(!isLastItem(item, j) && tableStyles.rightBorder, getColumnWidth(j), formColumnWidth(cell === null || cell === void 0 ? void 0 : cell.style, (_a = header[j]) === null || _a === void 0 ? void 0 : _a.minWidth))
              }, getTestId(testID, "table_cell_" + i + "_" + j)));
            })]
          }))
        }, "table_cell_" + i);
      })
    })) : _jsx(View, Object.assign({
      style: tableStyles.noDataContainer
    }, {
      children: _jsx(Typography, Object.assign({
        type: "body-para-sm-bold",
        text: noDataText
      }, getTestId(testID, 'noDataText')))
    }))]
  }));
};